import React from 'react';

// --- SVGs & Icons ---

const StarIcon = ({ size = 20, fill = "currentColor", style = {}, className = "" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill={fill} style={style}
        className={className}>
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
    </svg>
);

const HouseIcon = ({ size = 35, color = "#0288D1" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
        strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
);

// Custom Smiley Face
const SmileyFace = ({ color, size = 45, style }) => (
    <div style={{
        ...style,
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: color,
        border: '1px solid white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '1px 1px 2px rgba(0,0,0,0.1)',
        zIndex: 5
    }}>
        <div style={{ position: 'relative', width: '100%', height: '100%' }}>
            {/* Eyes */}
            <div style={{
                position: 'absolute',
                top: '30%',
                left: '28%',
                width: '12%',
                height: '12%',
                borderRadius: '50%',
                backgroundColor: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <div style={{ width: '60%', height: '60%', background: 'black', borderRadius: '50%' }}></div>
            </div>
            <div style={{
                position: 'absolute',
                top: '30%',
                right: '28%',
                width: '12%',
                height: '12%',
                borderRadius: '50%',
                backgroundColor: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <div style={{ width: '60%', height: '60%', background: 'black', borderRadius: '50%' }}></div>
            </div>
            {/* Smile */}
            <svg width="100%" height="100%" style={{ position: 'absolute', top: 3, left: 0 }}>
                <path d="M 14 28 Q 22 36 30 28" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round" />
            </svg>
        </div>
    </div>
);

/**
 * Logic unchanged
 */
const calculateAgeFromBirthday = (birthday) => {
    if (!birthday) return '';
    try {
        const birthDate = new Date(birthday);
        if (isNaN(birthDate.getTime())) return '';
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age >= 0 ? age : 0;
    } catch (e) {
        console.error("Error calculating age:", e);
        return '';
    }
};

const PartA2 = ({ data = {} }) => {
    const calculatedAge = data.birthday ? calculateAgeFromBirthday(data.birthday) : '';

    const safeData = {
        age_years: data.age_years || calculatedAge || '7',
        birthday: data.birthday || '2017-01-01',
        live_in: data.live_in || "Delhi",
        family: data.family || "",
        want_to_be: data.want_to_be || "A Scientist",
        friends_are: data.friends_are || "Radhika, Anjali and Hiten",
        favourite_colour: data.favourite_colour || "Blue",
        favourite_food: data.favourite_food || "Pizza",
        favourite_animal: data.favourite_animal || "Lion",
        favourite_flower: data.favourite_flower || "Rose",
        favourite_sport: data.favourite_sport || "Football",
        favourite_subject: data.favourite_subject || "Science",
    };

    const formattedBirthday = safeData.birthday ? new Date(safeData.birthday).toLocaleDateString('en-GB', {
        day: '2-digit', month: '2-digit', year: 'numeric'
    }) : '';

    return (
        <div style={styles.page}>
            {/* --- HEADER --- */}
            <div style={styles.subHeader}>PART-A (2)</div>

            <div style={styles.titleBanner}>
                {/* Left Stars */}
                <StarIcon size={24} fill="white"
                    style={{ position: 'absolute', left: '20px', top: '12px', transform: 'rotate(-15deg)' }} />
                <StarIcon size={14} fill="white" style={{ position: 'absolute', left: '45px', top: '38px' }} />

                <span style={styles.titleText}>ME AND MY SURROUNDINGS</span>

                {/* Right Star */}
                <StarIcon size={24} fill="#CDDC39"
                    style={{ position: 'absolute', right: '25px', top: '12px', transform: 'rotate(15deg)' }} />
            </div>

            {/* --- LEFT SIDE: FRAMES --- */}

            {/* 1. "THIS IS ME" Frame */}
            <div
                style={{ position: 'absolute', top: '150px', left: '40px', width: '380px', height: '260px', zIndex: 10 }}>
                <div style={styles.thisIsText}>THIS IS</div>

                <StarIcon size={22} fill="#FDD835"
                    style={{ position: 'absolute', top: '25px', left: '130px', transform: 'rotate(-20deg)' }} />
                <StarIcon size={14} fill="#D32F2F" style={{ position: 'absolute', top: '20px', left: '155px' }} />
                <StarIcon size={20} fill="#CDDC39"
                    style={{ position: 'absolute', top: '30px', left: '175px', transform: 'rotate(20deg)' }} />

                <svg width="100%" height="100%"
                    style={{ position: 'absolute', top: 0, left: 0, overflow: 'visible', pointerEvents: 'none' }}>
                    <path d="M 60 60 L 250 50 Q 270 50 270 70 L 265 180 Q 265 200 245 200 L 220 200"
                        stroke="black" strokeWidth="2.5" fill="none" strokeLinecap="round" />
                    <path d="M 60 60 L 60 120" stroke="black" strokeWidth="2.5" fill="none" strokeLinecap="round" />
                </svg>

                <div style={styles.meLabel}>
                    ME
                    <StarIcon size={12} fill="black" style={{ position: 'absolute', top: '-2px', right: '-8px' }} />
                </div>
            </div>

            {/* 2. Family Section */}
            <div style={{ position: 'absolute', top: '360px', left: '20px', width: '380px', height: '260px' }}>
                <SmileyFace color="#FFEB3B" size={50} style={{ position: 'absolute', top: '0', left: '15px' }} />
                <SmileyFace color="#D81B60" size={50} style={{ position: 'absolute', top: '0', left: '100px' }} />

                <svg width="100%" height="100%"
                    style={{ position: 'absolute', top: '25px', left: '0', overflow: 'visible', zIndex: 1 }}>
                    <path d="M 150 25 L 300 25 Q 320 25 320 45 L 320 200 Q 320 220 300 220 L 160 220"
                        stroke="#00C853" strokeWidth="5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M 40 25 L 40 160" stroke="#00C853" strokeWidth="5" fill="none" strokeLinecap="round" />
                </svg>

                <div style={styles.familyText}>
                    This is<br />my family
                    <div style={{
                        width: '120px',
                        height: '3px',
                        backgroundColor: '#90A4AE',
                        marginTop: '3px',
                        marginLeft: '5px'
                    }}></div>
                </div>
            </div>

            {/* 3. "I WANT TO BE A" Box */}
            <div style={styles.wantToBeBox}>
                <div style={{ fontWeight: 'bold', fontSize: '12pt', marginBottom: '5px', color: 'black' }}>I WANT TO BE
                    A
                </div>
                <div style={styles.wantToBeInput}>{safeData.want_to_be}</div>
                <div style={{ fontWeight: 'bold', fontSize: '10pt', marginTop: '5px', color: 'black' }}>WHEN I GROW UP
                </div>

                <StarIcon size={40} fill="#0288D1"
                    style={{ position: 'absolute', top: '-15px', right: '-15px', transform: 'rotate(15deg)' }} />
            </div>


            {/* --- RIGHT SIDE --- */}

            {/* 1. Age Section */}
            <div style={{ position: 'absolute', top: '150px', right: '180px', textAlign: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <span
                        style={{ color: '#E65100', fontSize: '18pt', fontWeight: 'bold', marginRight: '8px' }}>I AM</span>
                    <div style={styles.ageCircle}>{safeData.age_years}</div>
                </div>
                <div style={{ color: '#E65100', fontSize: '16pt', fontWeight: 'bold', marginTop: '2px' }}>
                    YEARS OLD
                    <StarIcon size={16} fill="#FFB300"
                        style={{ display: 'inline-block', marginLeft: '5px', verticalAlign: 'middle' }} />
                </div>
            </div>

            {/* 2. Birthday Balloon */}
            <div style={styles.balloonContainer}>
                <div style={styles.balloon}>
                    <div style={{ color: 'white', textAlign: 'center', lineHeight: '1.1', paddingTop: '15px' }}>
                        <div style={{ fontSize: '10pt', fontFamily: '"Comic Sans MS"' }}>My</div>
                        <div style={{ fontSize: '13pt', fontWeight: 'bold', fontFamily: '"Comic Sans MS"' }}>Birthday
                        </div>
                        <div style={{ fontSize: '10pt', fontFamily: '"Comic Sans MS"' }}>is on</div>
                    </div>
                    <div style={styles.balloonDateBox}>
                        {formattedBirthday}
                    </div>
                    <div style={styles.balloonShine}></div>
                    <div style={styles.balloonKnot}></div>
                </div>
                <svg width="60" height="250"
                    style={{ position: 'absolute', top: '120px', right: '40px', overflow: 'visible', zIndex: 1 }}>
                    <path d="M 30 0 Q 30 50 10 100 Q -10 150 5 220" stroke="#333" strokeWidth="1" fill="none" />
                </svg>
            </div>

            {/* 3. "I live in" Cloud */}
            <div style={{ position: 'absolute', top: '250px', right: '35px', width: '310px' }}>
                <div style={{
                    textAlign: 'center',
                    color: '#039BE5',
                    fontSize: '20pt',
                    fontWeight: 'bold',
                    marginBottom: '-15px',
                    zIndex: 5,
                    position: 'relative'
                }}>I live in
                </div>
                <div style={styles.cloudBox}>
                    <div style={{
                        width: '85%',
                        borderBottom: '3px dotted #29B6F6',
                        margin: '25px auto 0 auto',
                        textAlign: 'center',
                        fontSize: '15pt',
                        color: '#0277BD',
                        fontWeight: 'bold',
                        paddingBottom: '2px'
                    }}>
                        {safeData.live_in}
                    </div>
                    <div style={{ width: '85%', borderBottom: '3px dotted #29B6F6', margin: '15px auto 0 auto' }}></div>
                    <div style={{ width: '85%', borderBottom: '3px dotted #29B6F6', margin: '15px auto 0 auto' }}></div>

                    <div style={{ position: 'absolute', right: '35px', bottom: '18px' }}>
                        <HouseIcon size={35} color="#039BE5" />
                    </div>
                </div>
            </div>

            {/* 4. Friends Section */}
            <div style={styles.friendsContainer}>
                <StarIcon size={55} fill="#D32F2F" style={{
                    position: 'absolute',
                    top: '-25px',
                    left: '-25px',
                    transform: 'rotate(-15deg)',
                    zIndex: 10
                }} />

                <div style={{ marginTop: '15px', paddingLeft: '8px' }}>
                    {safeData.friends_are.split(',').concat(['', '', '', '']).slice(0, 5).map((friend, i) => (
                        <div key={i} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                            <div style={{
                                width: '10px',
                                height: '10px',
                                borderRadius: '50%',
                                backgroundColor: '#8E24AA',
                                marginRight: '10px'
                            }}></div>
                            <div style={{
                                flexGrow: 1,
                                borderBottom: '2.5px dotted black',
                                height: '20px',
                                fontSize: '12pt',
                                fontWeight: 'bold',
                                color: 'black',
                                paddingLeft: '5px'
                            }}>{friend.trim()}</div>
                        </div>
                    ))}
                </div>

                <div style={styles.friendsBadge}>
                    are my friends
                </div>
            </div>


            {/* --- BOTTOM SECTION --- */}
            <div style={styles.bottomSection}>
                <StarIcon size={30} fill="#76FF03" style={{ position: 'absolute', top: '15px', left: '15px' }} />
                <StarIcon size={25} fill="#FFC107"
                    style={{ position: 'absolute', top: '-10px', right: '30px', transform: 'rotate(20deg)' }} />

                <div style={styles.favHeader}>
                    My Favourite :
                </div>

                <div style={styles.favGrid}>
                    <div style={{ width: '48%' }}>
                        <FavItem icon="🎨" label="COLOUR" labelColor="#8E24AA" value={safeData.favourite_colour} />
                        <FavItem icon="🍽️" label="FOOD" labelColor="#EF6C00" value={safeData.favourite_food} />
                        <FavItem icon="🦌" label="ANIMAL" labelColor="#00695C" value={safeData.favourite_animal} />
                    </div>
                    <div style={{ width: '48%' }}>
                        <FavItem icon="🌸" label="FLOWER" labelColor="#303F9F" value={safeData.favourite_flower} />
                        <FavItem icon="⚽" label="SPORT" labelColor="#D32F2F" value={safeData.favourite_sport} />
                        <FavItem icon="📚" label="SUBJECT" labelColor="#0288D1" value={safeData.favourite_subject} />
                    </div>
                </div>
            </div>
        </div>
    );
};

// Helper for Footer Items
const FavItem = ({ icon, label, labelColor, value }) => (
    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
        <span style={{ fontSize: '20pt', width: '45px', textAlign: 'center' }}>{icon}</span>
        <span style={{
            fontSize: '15pt',
            fontWeight: 'bold',
            color: labelColor,
            width: '110px',
            fontFamily: '"Comic Sans MS"'
        }}>{label}</span>
        <div style={{
            flexGrow: 1,
            backgroundColor: '#FFAB91',
            height: '32px',
            borderRadius: '0 16px 16px 0',
            display: 'flex',
            alignItems: 'center',
            paddingLeft: '15px',
            color: 'white',
            fontWeight: 'bold',
            fontSize: '13pt',
            fontFamily: '"Comic Sans MS"',
            position: 'relative'
        }}>
            <div style={{
                position: 'absolute', left: '-10px', top: '0', bottom: '0', width: '20px',
                backgroundColor: '#FFAB91', zIndex: -1,
                clipPath: 'polygon(100% 0, 100% 100%, 0 50%)'
            }}></div>
            {value}
        </div>
    </div>
);

// --- STYLES ---
const styles = {
    page: {
        width: '210mm',
        height: '297mm',
        backgroundColor: '#FFF8E1',
        position: 'relative',
        margin: '0 auto',
        fontFamily: '"Comic Sans MS", "Chalkboard SE", sans-serif',
        overflow: 'hidden',
        boxSizing: 'border-box',
    },
    subHeader: {
        textAlign: 'center',
        color: '#BF360C',
        fontWeight: 'bold',
        fontSize: '10pt',
        marginTop: '15px',
    },
    titleBanner: {
        backgroundColor: '#BF360C',
        width: '92%',
        margin: '5px auto',
        borderRadius: '50px',
        padding: '10px 0',
        textAlign: 'center',
        position: 'relative',
        boxShadow: '0 4px 0 rgba(0,0,0,0.1)'
    },
    titleText: {
        color: 'white',
        fontSize: '26pt',
        fontWeight: '900',
        letterSpacing: '1px',
        textShadow: '2px 2px 0px #3E2723'
    },
    thisIsText: {
        position: 'absolute',
        top: '30px',
        left: '20px',
        fontSize: '32pt',
        fontWeight: '900',
        transform: 'rotate(-25deg)',
        color: 'black',
        zIndex: 20
    },
    meLabel: {
        position: 'absolute',
        bottom: '65px',
        right: '120px',
        fontSize: '28pt',
        fontWeight: '900',
        transform: 'rotate(-10deg)',
        color: 'black',
        fontFamily: '"Comic Sans MS"'
    },
    familyText: {
        position: 'absolute',
        bottom: '20px',
        left: '10px',
        color: '#D32F2F',
        fontSize: '18pt',
        fontWeight: 'bold',
        lineHeight: '1.1',
        fontFamily: '"Comic Sans MS"'
    },
    wantToBeBox: {
        position: 'absolute',
        top: '640px',
        left: '60px',
        width: '320px',
        height: '110px',
        backgroundColor: 'white',
        border: '5px solid #7B1FA2',
        borderRadius: '30px 0 30px 0',
        padding: '10px 20px',
        boxSizing: 'border-box',
        textAlign: 'center'
    },
    wantToBeInput: {
        borderBottom: '3px solid black',
        width: '100%',
        margin: '5px auto',
        height: '25px',
        fontSize: '15pt',
        fontWeight: 'bold',
        color: '#333'
    },
    ageCircle: {
        width: '50px',
        height: '50px',
        backgroundColor: 'white',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '22pt',
        fontWeight: 'bold',
        color: 'black',
        boxShadow: '1px 1px 3px rgba(0,0,0,0.2)'
    },
    balloonContainer: {
        position: 'absolute',
        top: '100px',
        right: '20px',
        zIndex: 10
    },
    balloon: {
        width: '125px',
        height: '135px',
        backgroundColor: '#7B1FA2',
        borderRadius: '50% 50% 50% 50% / 40% 40% 60% 60%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        boxShadow: '2px 2px 4px rgba(0,0,0,0.2)'
    },
    balloonDateBox: {
        marginTop: '5px',
        backgroundColor: 'white',
        borderRadius: '10px',
        padding: '2px 8px',
        color: '#7B1FA2',
        fontWeight: 'bold',
        fontSize: '10pt',
        minWidth: '85px',
        textAlign: 'center',
        border: '1px solid #7B1FA2'
    },
    balloonShine: {
        position: 'absolute',
        top: '20px',
        left: '25px',
        width: '30px',
        height: '15px',
        borderRadius: '50%',
        backgroundColor: 'rgba(255,255,255,0.3)',
        transform: 'rotate(-30deg)'
    },
    balloonKnot: {
        position: 'absolute',
        bottom: '-5px',
        width: '10px',
        height: '8px',
        backgroundColor: '#7B1FA2',
        borderRadius: '2px'
    },
    cloudBox: {
        backgroundColor: 'white',
        borderRadius: '60px',
        width: '100%',
        height: '130px',
        position: 'relative',
        boxShadow: '0 0 0 0px transparent'
    },
    friendsContainer: {
        position: 'absolute',
        top: '430px',
        right: '30px',
        width: '320px',
        height: '230px',
        backgroundColor: 'white',
        border: '8px solid #0288D1',
        boxSizing: 'border-box',
        padding: '15px'
    },
    friendsBadge: {
        position: 'absolute',
        bottom: '-18px',
        right: '20px',
        backgroundColor: '#F57C00',
        color: 'white',
        fontWeight: 'bold',
        fontSize: '14pt',
        padding: '5px 25px',
        borderRadius: '20px 0 20px 0',
        border: '3px solid white',
        boxShadow: '1px 1px 3px rgba(0,0,0,0.1)',
        fontFamily: '"Comic Sans MS"'
    },
    // --- UPDATED BOTTOM SECTION STYLES ---
    bottomSection: {
        position: 'absolute',
        bottom: '55px', // Moved up from 0 to 25px
        left: '20px',
        right: '20px',
        height: '235px', // Increased height slightly
        backgroundColor: 'white',
        borderRadius: '40px 40px 0 0',
        padding: '20px 40px',
        boxSizing: 'border-box',
        zIndex: 5
    },
    favHeader: {
        textAlign: 'center',
        color: '#01579B',
        fontSize: '28pt',
        fontWeight: '900',
        fontFamily: '"Comic Sans MS"',
        marginBottom: '20px',
        letterSpacing: '-1px'
    },
    favGrid: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    pageNumber: {
        position: 'absolute',
        bottom: '5px',
        width: '100%',
        textAlign: 'center',
        color: '#9E9E9E',
        fontSize: '9pt',
        zIndex: 10
    }
};

export default PartA2;